import React from 'react';
import PropTypes from 'prop-types';

const Bio = props => <div dangerouslySetInnerHTML={{ __html: props.data.bio }} />;

Bio.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Bio;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/bio.js